{
  "EMOJI": {
    "PLACEHOLDER": "Wyszukaj emoji",
    "NOT_FOUND": "Nie znaleziono emoji pasującego do wyszukiwania",
    "REMOVE": "Usuń"
  }
}
